import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocalStorage {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  store(key: string, data: unknown): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  }

  get<T>(key: string): T | null {
    if (isPlatformBrowser(this.platformId)) {
      const storedData = localStorage.getItem(key);
      return storedData ? (JSON.parse(storedData) as T) : null;
    }
    return null;
  }

  remove(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  clear(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
